import RuejaiClubBannerListPage from "./pages/RuejaiClubBannerListPage";
import RuejaiClubBannerDetailPage from "./pages/RuejaiClubBannerDetailPage";
import RuejaiClubBannerCreatePage from "./pages/RuejaiClubBannerCreatePage";

export const ruejaiClubBannerRoutes = (prefix = "banners") => [
  {
    name: "RuejaiClubBannerDetailPage",
    path: `${prefix}/:id`,
    component: RuejaiClubBannerDetailPage
  },
  {
    name: "RuejaiClubBannerCreatePage",
    path: `${prefix}/create`,
    component: RuejaiClubBannerCreatePage
  },
  {
    name: "RuejaiClubBannerListPage",
    path: prefix,
    component: RuejaiClubBannerListPage
  }
];
